module.exports = __webpack_public_path__ + "static/media/iloop.1390df61.svg";